<div class="loader-container">
    <app-loader *ngIf="loading == true"></app-loader>
    <app-modal-header *ngIf="modalStyle === true" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{
        'modal-body': modalStyle === true
    }">
        <div *ngIf="errorMessage && errorMessage.length" class="alert alert-danger d-flex align-items-center"
            role="alert">
            <div>
                {{errorMessage}}
            </div>
        </div>

        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">Naam</label>
                <input [ngClass]="{'is-invalid': errors['name']}" type="text" [(ngModel)]="item['name']"
                    class="form-control" placeholder="Naam docent">
            </div>
        </div>
        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">E-mail</label>
                <input type="text" [(ngModel)]="item['email']" class="form-control">
            </div>
        </div>
        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">School</label>
                <select disabled class="form-control" [(ngModel)]="item['organisation_id']">
                    <ng-container *ngFor="let organisation of organisations">
                        <option [value]="organisation['id']">
                            {{organisation['name']}}
                        </option>
                    </ng-container>
                </select>
            </div>
        </div>
        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">Rol</label>
                <select class="form-control" [(ngModel)]="item['role_id']">
                    <ng-container *ngFor="let role of roles">
                        <option *ngIf="availableRoles.includes(role['key'])" [value]="role['id']">
                            {{role['name']}}
                        </option>
                    </ng-container>
                </select>
            </div>
        </div>
        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">Wachtwoord</label>
                <input type="password" [(ngModel)]="newPassword" class="form-control">
            </div>
        </div>
        <div class="form-buttons">
            <button type="button" class="btn btn-primary" (click)="save()">Opslaan</button>
        </div>
    </div>
</div>